import { ecommerce } from "../messages/ecommerce";
import { common } from "../messages";
import { wikiMuseo } from "../messages/wikiMuseo";

export const RESERVATIONS_STATUS = new Map([
  ["x", common.anyStatus],
  [0, ecommerce.toConfirm],
  [2, ecommerce.confirmed],
]);

export const RESERVATIONS_VISITOR_TYPES = {
  school: wikiMuseo.school,
  association: wikiMuseo.association,
  touristic_operator: wikiMuseo.touristicOperator,
  private: wikiMuseo.privateGroup,
};

export const RESERVATIONS_VISITOR_TYPES_RESTRICTED = {
  school: wikiMuseo.school,
  group_less_50: wikiMuseo.group_less_50,
  group_more_50: wikiMuseo.group_more_50,
};

export const RESERVATIONS_GROUP_TYPES = {
  specialized_agency: ecommerce.groupSubtypeSpecializedAgency,
  public_institution: ecommerce.groupSubtypePublicInstitution,
  nonprofit_third_sector: ecommerce.groupSubtypeNonprofit,
  company: ecommerce.groupSubtypeCompany,
};

export const RESERVATIONS_SCHOOL_TYPES = {
  elementary_school: ecommerce.schoolTypeElementary,
  middle_school: ecommerce.schoolTypeMiddle,
  high_school: ecommerce.schoolTypeHigh,
};

export const RESERVATIONS_CLASS_TYPES = {
  prime: ecommerce.classTypeFirst,
  seconde: ecommerce.classTypeSecond,
  terze: ecommerce.classTypeThird,
  quarte: ecommerce.classTypeFourth,
  quinte: ecommerce.classTypeFifth,
};

export const RESERVATIONS_CLASS_TYPES_MIDDLE = {
  prime: ecommerce.classTypeFirst,
  seconde: ecommerce.classTypeSecond,
  terze: ecommerce.classTypeThird,
};

export const RESERVATIONS_VISIT_LANGUAGES = {
  it: common.italian,
  en: common.english,
};
